import React, { useState } from "react";
import { Redirect } from "react-router";
import { Form } from "react-bootstrap";
import { CollaspeButton } from "./CollaspeButton";
import { FilterPanel } from "../FilterPanel";
import ErrorBoundary from "lib/ErrorBoundary";

export const SidePanel = ({ aggregations }) => {
  const [collasped, setCollasped] = useState(false);
  const collaspingWidth = collasped ? "auto" : 275;

  return (
    <ErrorBoundary>
      <Form className="search-filter" style={{ width: collaspingWidth }}>
        {!collasped ? <FilterPanel aggregations={aggregations} /> : null}
        <CollaspeButton collasped={collasped} setCollasped={setCollasped} />
      </Form>
    </ErrorBoundary>
  );
};

export const GotoRedesign = () => <Redirect to="/Economics" />;
